import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  Box, Card, TextField, Button, Typography, Alert, CircularProgress,
} from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';

const PURPLE = '#00F1A7';
const DARK = '#1C1C1E';
const API = process.env.REACT_APP_API_URL || 'https://api.conectachurch.com.br';

function RedefinirSenha() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');

    if (novaSenha.length < 6) {
      setErro('A senha deve ter no mínimo 6 caracteres');
      return;
    }
    if (novaSenha !== confirmarSenha) {
      setErro('As senhas não conferem');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/redefinir-senha`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, nova_senha: novaSenha }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.detail || 'Erro ao redefinir senha');
      }

      setSucesso(true);
      setTimeout(() => navigate('/login', { replace: true }), 2000);
    } catch (err) {
      setErro(err.message || 'Erro ao conectar ao servidor');
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#F6F7F3', p: 3 }}>
        <Card sx={{ maxWidth: 400, width: '100%', p: 4, borderRadius: 1, boxShadow: '0 4px 32px rgba(0,0,0,0.07)', border: '1px solid #E8E8E8' }}>
          <Alert severity="error" sx={{ borderRadius: 1 }}>Token inválido ou expirado.</Alert>
          <Button fullWidth onClick={() => navigate('/login', { replace: true })} variant="outlined" sx={{ mt: 2 }}>
            Ir para o login
          </Button>
        </Card>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#F6F7F3', p: 3 }}>
      <Card sx={{ maxWidth: 400, width: '100%', p: 4, borderRadius: 1, boxShadow: '0 4px 32px rgba(0,0,0,0.07)', border: '1px solid #E8E8E8' }}>

        {sucesso ? (
          <Box sx={{ textAlign: 'center', py: 3 }}>
            <CheckCircle sx={{ fontSize: 56, color: '#4CAF50', mb: 2 }} />
            <Typography variant="h6" sx={{ color: DARK, mb: 1 }}>Senha redefinida!</Typography>
            <Typography variant="body2" sx={{ color: '#888' }}>Redirecionando para o login...</Typography>
          </Box>
        ) : (
          <>
            <Typography variant="h5" sx={{ mb: 0.5, color: DARK, fontWeight: 700 }}>Redefinir senha</Typography>
            <Typography variant="body2" sx={{ mb: 3.5, color: '#999' }}>Escolha uma nova senha para sua conta</Typography>

            <Box component="form" onSubmit={handleSubmit} noValidate>
              <TextField
                fullWidth
                label="Nova senha"
                type="password"
                value={novaSenha}
                onChange={e => setNovaSenha(e.target.value)}
                required
                autoFocus
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label="Confirmar senha"
                type="password"
                value={confirmarSenha}
                onChange={e => setConfirmarSenha(e.target.value)}
                required
                sx={{ mb: erro ? 2 : 3 }}
              />

              {erro && (
                <Alert severity="error" sx={{ mb: 3, borderRadius: 1, fontSize: 13 }}>{erro}</Alert>
              )}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={loading}
                sx={{
                  py: 1.4, fontSize: '0.95rem', fontWeight: 700,
                  bgcolor: PURPLE, '&:hover': { bgcolor: '#00C48C' },
                }}
                startIcon={loading ? <CircularProgress size={16} sx={{ color: '#fff' }} /> : null}
              >
                {loading ? 'Redefinindo...' : 'Redefinir senha'}
              </Button>
            </Box>
          </>
        )}
      </Card>
    </Box>
  );
}

export default RedefinirSenha;
